import { styled } from '@mui/material/styles'
import { Unstable_SankeyChart as SankeyChart } from '@mui/x-charts-pro/SankeyChart'
import { Card, Empty, theme } from 'antd'
import { ConversionLegend, conversionColors as colors } from './ConversionLegend'
import { BookingConversionSankeyData } from './sankey'

interface Props {
  sankeyData: BookingConversionSankeyData
  isLoading: boolean
  error?: string
}

const BookingConversionSankey = ({ sankeyData, isLoading, error }: Props) => {
  const { token } = theme.useToken()
  const getNodeColor = (data: any) => {
    if (data.isFailTerminaison) {
      return colors.red
    } else if (data.isSuccessTerminaison) {
      return colors.green
    } else if (data.loss > 60) {
      return colors.red
    } else if (data.loss > 30) {
      return colors.orange
    } else {
      return colors.green
    }
  }

  const ThemedSankeyChart = styled(SankeyChart)`
    .MuiSankeyChart-nodes text {
      fill: ${token.colorText} !important;
    }

    .MuiSankeyChart-linkLabels text {
      fill: ${token.colorTextSecondary} !important;
    }
  `

  return (
    <Card loading={isLoading}>
      {(sankeyData.nodes.length === 0 || error) && !isLoading && (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={error} />
      )}
      {sankeyData.nodes && !isLoading && !error && (
        <ThemedSankeyChart
          height={500}
          series={{
            data: {
              nodes: sankeyData.nodes.map((item) => ({
                ...item,
                label: `${item.label}`,
                color: getNodeColor(item.data),
              })),
              links: sankeyData.links,
            },
            nodeOptions: {
              align: 'justify',
              sort: 'fixed',
              padding: 200,
              width: 15,
            },
            linkOptions: {
              color: token.colorBgContainerDisabled,
              opacity: 1,
              showValues: true,
              sort: 'fixed',
              curveCorrection: 0.8,
            },
            valueFormatter: (value, context) => {
              if (context.type === 'link') {
                const sourceNode = sankeyData.nodes.find(
                  (n) => n.id === context.sourceId
                )
                if (sourceNode?.data?.count) {
                  const percentage = (
                    (value / sourceNode.data.count) *
                    100
                  ).toFixed(1)

                  if (context.location === 'tooltip') {
                    return `${value} events (${percentage}%)`
                  }

                  return `${percentage}%`
                }
              }

              if (context.type === 'node' && context.location === 'tooltip') {
                const node = sankeyData.nodes.find(
                  (n) => n.id === context.nodeId
                )
                if (node?.data) {
                  let tooltip = `${value}`
                  if (node.data.loss !== undefined && node.data.loss > 0) {
                    tooltip += ` (Loss: ${node.data.loss}%)`
                  }
                  return tooltip
                }
              }

              return `${value}`
            },
          }}
        />
      )}
      <ConversionLegend mode="loss" />
    </Card>
  )
}

export default BookingConversionSankey
